import { type RouteRecordRaw } from 'vue-router'

const documentsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/documents/:id',
    name: 'documents.show',
    component: () => import('@/modules/ism-documents/views/DocumentShowView.vue'),
    meta: {
      pageTitle: 'Document',
      breadcrumbs: ['Documents']
    }
  },
  {
    path: '/manuals',
    name: 'manuals.index',
    component: () => import('@/modules/ism-documents/views/ManualsIndex.vue'),
    meta: {
      pageTitle: 'Manuals',
      breadcrumbs: ['Manuals']
    }
  },
  {
    path: '/procedures',
    name: 'procedures.index',
    component: () => import('@/modules/ism-documents/views/ProceduresIndex.vue'),
    meta: {
      pageTitle: 'Procedures',
      breadcrumbs: ['Procedures']
    }
  },
  {
    path: '/posters',
    name: 'posters.index',
    component: () => import('@/modules/ism-documents/views/PostersIndex.vue'),
    meta: {
      pageTitle: 'Posters',
      breadcrumbs: ['Posters']
    }
  },
  {
    path: '/forms',
    name: 'forms.index',
    component: () => import('@/modules/ism-documents/views/FormsIndex.vue'),
    meta: {
      pageTitle: 'Forms',
      breadcrumbs: ['Forms']
    }
  },
  {
    path: '/checklists',
    name: 'checklists.index',
    component: () => import('@/modules/ism-documents/views/ChecklistsIndex.vue'),
    meta: {
      pageTitle: 'Checklists',
      breadcrumbs: ['Checklists']
    }
  },
  {
    path: '/risk-assessments',
    name: 'risk-assessments.index',
    component: () => import('@/modules/ism-documents/views/RiskAssessmentsIndex.vue'),
    meta: {
      pageTitle: 'Risk assessments',
      breadcrumbs: ['Risk assessments']
    }
  },
  {
    path: '/crew/job-descriptions',
    name: 'job-descriptions.index',
    component: () => import('@/modules/ism-documents/views/JobDescriptionsIndex.vue'),
    meta: {
      pageTitle: 'Job descriptions',
      breadcrumbs: ['Job descriptions']
    }
  },
  {
    path: '/crew/crew-courses-matrix',
    name: 'crew-courses-matrix.index',
    component: () => import('@/modules/ism-documents/views/CrewCoursesMatrixIndex.vue'),
    meta: {
      pageTitle: 'Crew courses matrix',
      breadcrumbs: ['Crew courses matrix']
    }
  },
  {
    path: '/crew/certificates',
    name: 'crew-certificates.index',
    component: () => import('@/modules/ism-documents/views/CrewCertificatesIndex.vue'),
    meta: {
      pageTitle: 'Crew certificates',
      breadcrumbs: ['Crew certificates']
    }
  },
  {
    path: '/crew-agencies',
    name: 'crew-agencies.index',
    component: () => import('@/modules/ism-documents/views/CrewAgenciesIndex.vue'),
    meta: {
      pageTitle: 'Crew agencies',
      breadcrumbs: ['Crew agencies']
    }
  },
  {
    path: '/contingency-plans',
    name: 'contingency-plans.index',
    component: () => import('@/modules/ism-documents/views/ContingencyPlansIndex.vue'),
    meta: {
      pageTitle: 'Contingency plans',
      breadcrumbs: ['Contingency plans']
    }
  },
  {
    path: '/communication',
    name: 'communication.index',
    component: () => import('@/modules/ism-documents/views/CommunicationIndex.vue'),
    meta: {
      pageTitle: 'Communication',
      breadcrumbs: ['Communication']
    }
  },
  {
    path: '/office/job-descriptions',
    name: 'office-job-descriptions.index',
    component: () => import('@/modules/ism-documents/views/OfficeJobDescriptionsIndex.vue'),
    meta: {
      pageTitle: 'Office job descriptions',
      breadcrumbs: ['Office job descriptions']
    }
  },
  {
    path: '/office/forms',
    name: 'office-forms.index',
    component: () => import('@/modules/ism-documents/views/OfficeFormsIndex.vue'),
    meta: {
      pageTitle: 'Office forms',
      breadcrumbs: ['Office forms']
    }
  },
  {
    path: '/office/procedures',
    name: 'office-procedures.index',
    component: () => import('@/modules/ism-documents/views/OfficeProceduresIndex.vue'),
    meta: {
      pageTitle: 'Office procedures',
      breadcrumbs: ['Office procedures']
    }
  },
  {
    path: '/docking-reports',
    name: 'docking-reports.index',
    component: () => import('@/modules/ism-documents/views/DockingReports.vue'),
    meta: {
      pageTitle: 'Docking reports',
      breadcrumbs: ['Docking reports']
    }
  },
  {
    path: '/drawings',
    name: 'drawings.index',
    component: () => import('@/modules/ism-documents/views/DrawingsIndex.vue'),
    meta: {
      pageTitle: 'Drawings',
      breadcrumbs: ['Drawings']
    }
  }
]

export default documentsRoutes
